import React, { Suspense, useEffect, useState } from "react";

const Slider = React.lazy(() => import("react-slick"));

const SliderArrow = ({ direction, currentSlide, slideCount, ...buttonProps }) => (
  <button
    {...buttonProps}
    className={`slick-arrow slick-${direction}`}
    aria-label={`${direction === 'prev' ? 'Previous' : 'Next'} Slide`}
  >
    <i className={`fa-solid fa-arrow-${direction === 'prev' ? 'left' : 'right'}`}></i>
  </button>
);
const servicesData = [
  {
    icon: '/assets/images/serices-icon1.webp',
    title: 'Tracker Software for <br> Delivery',
    description: 'Our intelligent tracker software improves delivery efficiency with real-time monitoring, route optimization, and precise updates.',
    animation: "animate__slideInUp",
    delay: "0.1s",
    duration: "1s",
  },
  {
    icon: '/assets/images/serices-icon2.webp',
    title: 'Simplify Carrier <br>   Management',
    description: 'Easily manage carriers, reduce costs, and enhance logistics efficiency with smart, automated tools designed for long-term business sustainability.',
    animation: "animate__slideInUp ",
    delay: "0.2s",
    duration: "0.1s",

  },
  {
    icon: '/assets/images/serices-icon3.webp',
    title: 'Smart Route And   <br>  Dispatch',
    description: ' Plan optimized routes, automate dispatching, minimize delays, and maximize fleet productivity with scalable, real-time solutions.',
    animation: "animate__slideInUp ",
    delay: "0.2s",
    duration: "0.1s",
  },
  {
    icon: '/assets/images/serices-icon4.webp',
    title: 'The Best Customer <br> Experience',
    description: 'Provide personalized, seamless support that builds trust, strengthens satisfaction, and makes every interaction meaningful, valuable, and memorable.',
    animation: "animate__slideInUp ",
    delay: "0.2s",
    duration: "0.1s",
  },
  {
    icon: '/assets/images/serices-icon5.webp',
    title: 'Real-Time Order <br> Tracking',
    description: ' Stay on top of orders with end-to-end visibility, streamlined communication, and smart automation that reduces overheads and increases operational efficiency.',
    animation: "animate__slideInUp ",
    delay: "0.2s",
    duration: "0.1s",
  },
  {
    icon: '/assets/images/serices-icon6.webp',
    title: 'Low-code <br> Integrations',
    description: 'Easily connect with your existing systems using powerful low-code tools, enabling faster deployment, effortless scalability, and smarter automation.',
    animation: "animate__slideInUp ",
    delay: "0.2s",
    duration: "0.1s",
  },
  {
    icon: '/assets/images/serices-icon7.webp',
    title: 'Third-Party <br> Connectors',
    description: 'Connect seamlessly with existing systems using low-code integrations and collaborate effortlessly with external platforms through third-party connectors.',
    animation: "animate__slideInUp ",
    delay: "0.2s",
    duration: "0.1s",
  },
  {
    icon: '/assets/images/serices-icon8.webp',
    title: 'Future-ready <br>  Platform',
    description: 'Adapt, scale, and evolve with a platform designed to meet the challenges of rapidly changing business needs, keeping you ahead in the competitive landscape.',
    animation: "animate__slideInUp ",
    delay: "0.2s",
    duration: "0.1s",
  },
  {
    icon: '/assets/images/serices-icon9.webp',
    title: 'Consultative <br> Approach',
    description: ' We partner with you to deliver tailored strategies, actionable insights, and collaborative solutions that drive growth, efficiency, and long-term success.',
    animation: "animate__slideInUp ",
    delay: "0.2s",
    duration: "0.1s",
  },
];

export default function HomeServices() {
  const [useMobileSlider, setUseMobileSlider] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 991px)");
    const updateSliderMode = () => setUseMobileSlider(mediaQuery.matches);

    updateSliderMode();
    mediaQuery.addEventListener("change", updateSliderMode);
    return () => mediaQuery.removeEventListener("change", updateSliderMode);
  }, []);

  const settingskey = {
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 3000,
    cssEase: "ease",
    infinite: true,
    arrows: true,
    dots: false,
    pauseOnHover: false,
    slidesToShow: 1,
    slidesToScroll: 1,

    prevArrow: <SliderArrow direction="prev" />,
    nextArrow: <SliderArrow direction="next" />,

    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },


      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
        },
      },

      {
        breakpoint: 99999,
        settings: "unslick",
      },
    ],
  };


  return (
    <section className="home-services">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-12 col-lg-10">
            <div className="service-text">
              <h2 className="heading">Why Mobility TMS</h2>
              <p>
                Mobility TMS enhances logistics efficiency, providing real-time tracking, faster decision-making,
                and improved accuracy. It boosts productivity, reduces errors, and enables seamless communication across teams.
              </p>
            </div>
          </div>
        </div>
        {useMobileSlider ? (
          <Suspense fallback={(
            <div className="services-wrapper">
              {servicesData.map((service, index) => (
                <ServiceCard service={service} index={index} key={index} />
              ))}
            </div>
          )}>
            <Slider {...settingskey} className="services-wrapper">
              {servicesData.map((service, index) => (
                <ServiceCard service={service} index={index} key={index} />
              ))}
            </Slider>
          </Suspense>
        ) : (
          <div className="services-wrapper">
            {servicesData.map((service, index) => (
              <ServiceCard service={service} index={index} key={index} />
            ))}
          </div>
        )}

      </div>
    </section>
  );
}

function ServiceCard({ service, index }) {
  return (
            <div className={`services-col wow animate__animated ${service.animation}`} data-wow-delay={service.delay} data-wow-duration={service.duration} key={index}>
              <div className="services-gradient">
                <div className="services-col-inner">
                  <div className="icon">
                    <img src={service?.icon} alt={service?.title} className="img-fluid" loading="lazy"/>
                  </div>
                  <div className="heading" dangerouslySetInnerHTML={{ __html: service.title }} />
                  <p>{service.description}</p>
                </div>
              </div>
            </div>
  );
}
